module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiMobile-9087308125c5473b8a46d0006e5a394d.png";